import axios from "axios";

const put = ({ status, reason, id }) => {
  const body = {
    status: status,
    reason: reason
  };

  return new Promise((resolve, reject) => {
    axios
      .put(`/serialnumber/api/v1/consumer-warranty/${id}/verify`, body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const verifyWarranty = {
  put
};

export default verifyWarranty;
